import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

// Recuperar sesion de localStorage
const savedEjecutivo = localStorage.getItem('ejecutivo');

export default new Vuex.Store({
  state: {
    ejecutivo: savedEjecutivo ? JSON.parse(savedEjecutivo) : null
  },
  mutations: {
    setEjecutivo(state, data) {
      state.ejecutivo = data;
      localStorage.setItem('ejecutivo', JSON.stringify(data));
    },
    clearEjecutivo(state) {
      state.ejecutivo = null;
      localStorage.removeItem('ejecutivo');
    }
  },
  getters: {
    getEjecutivo(state) {
      return state.ejecutivo;
    },
    isLoggedIn(state) {
      return !!state.ejecutivo;
    }
  }
})
